<template >
  <div class="devDialog">
    <div class="devDialog-content">
      <div class="clearfix add-header">
        <div class="fl title">创建开发者</div>
        <div class="fr"><span style="color:red;">*</span> 为必填项</div>
      </div>
      <div class="form-box">
        <el-form ref="devForm" :model="devForm"  label-width="140px" :rules="rules">
          <div class="dev_form_title"><div>开发者账号</div></div>
          <el-form-item label="开发者手机号码"  class="is-required" prop="mobile" >
            <el-input v-model.trim="devForm.mobile" maxlength="32" placeholder="请输入手机号码..."> </el-input>
          </el-form-item>
          <el-form-item label="密码" class="is-required"  prop="password">
            <el-input v-model.trim="devForm.password" placeholder="请输入密码..."> </el-input>
          </el-form-item>
          <el-form-item label="确认密码" class="is-required"  prop="cfrmpassword">
            <el-input v-model.trim="devForm.cfrmpassword" placeholder="请输入确认密码..."> </el-input>
          </el-form-item>

          <div class="dev_form_title"><div>公司基本信息</div></div>
          <el-form-item label="公司全称" class="is-required"   prop="companyName">
            <el-input v-model.trim="devForm.companyName" maxlength="64" placeholder="请输入公司全称..."></el-input>
          </el-form-item>
          <el-form-item label="业务联系人" class="is-required"   prop="businessContact">
            <el-input v-model.trim="devForm.businessContact" maxlength="30" placeholder="请输入联系人..."></el-input>
          </el-form-item>
          <el-form-item label="手机号码" class="is-required" prop="contactNumber">
            <el-input v-model.trim="devForm.contactNumber" maxlength="13" placeholder="请输入联系电话..."></el-input>
          </el-form-item>
          <el-form-item label="详细地址" class="is-required" prop="companyAddress">
            <el-input v-model.trim="devForm.companyAddress" maxlength="200" placeholder="请输入公司地址..."></el-input>
          </el-form-item>
          <el-form-item label="官网地址" class="is-required" prop="companyWebsiteAddress">
            <el-input v-model.trim="devForm.companyWebsiteAddress" maxlength="200" placeholder="请输入公司网址..."></el-input>
          </el-form-item>
          <el-form-item label="营业执照号" prop="businessLicenseNumber">
            <el-input v-model.trim="devForm.businessLicenseNumber" maxlength="32" placeholder="请输入营业执照号..."></el-input>
          </el-form-item>
          <el-form-item label="营业执照" prop="businessLicenseUrl">
            <el-input v-model.trim="devForm.businessLicenseUrl" readonly placeholder="请上传正确营业执照照片"></el-input>
            <el-upload
              class="upload-demo"              
              :action="COMMON_UPLOAD_API"
              :on-success="handleSuccess"
              :headers="headers"
              :on-remove="handleRemove"
              :limit="1"
              :on-exceed="uploadHandle_exceed"
              :before-upload="uploadHandle_before"
              :file-list="fileList2"
              list-type="picture">
              <el-button size="small" type="primary">上传营业执照</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过10M</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <el-button type="primary" @click="save()" v-loading="loading">创建开发者</el-button>
          <el-button type="primary" @click="saveAndReset()" v-loading="loading">保存后继续创建</el-button>
          <el-button plain @click="reset()">重置</el-button>
        </div>
      </div>
    <!-- <el-dialog :title="title" :visible.sync="devDialogVisible" :close-on-click-modal="false"> -->

    <!-- </el-dialog> -->
    </div>
  </div>
</template>
<script type="text/babel">
import devService from '@/service/devService'
import { COMMON_UPLOAD_API } from '@/resource/index'
export default {
  name: 'editDevDialog',
  data () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.devForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      title: '新增开发者',
      loading: false,
      COMMON_UPLOAD_API: COMMON_UPLOAD_API,
      headers: {
        Authorization: this.$cookie.get('token')
      },
      id: this.$route.query.id,
      fileList2: [],
      devForm: {
        mobile: '',
        password: '',
        cfrmpassword: '',
        companyName: '',
        businessContact: '',
        contactNumber: '',
        companyAddress: '',
        companyWebsiteAddress: '',
        businessLicenseNumber: '',
        businessLicenseUrl: ''
      },
      rules: {
        mobile: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: ['blur', 'change']
          },
          {validator: this.$rules.phoneNumber, trigger: 'blur'}
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            min: 6,
            max: 18,
            message: '密码长度在 6 到 18 个字符',
            trigger: 'blur'
          }
        ],
        cfrmpassword: [
          {
            required: true,
            message: '请再次输入密码',
            trigger: ['blur', 'change']
          },
          { validator: validatePass2, trigger: 'blur' }
        ],
        companyName: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: ['blur', 'change']
          }
        ],
        businessContact: [
          {
            required: true,
            message: '请输入联系人',
            trigger: ['blur', 'change']
          }
        ],
        contactNumber: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: ['blur', 'change']
          },
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ],
        companyAddress: [
          {
            required: true,
            message: '请输入公司地址',
            trigger: ['blur', 'change']
          }
        ],
        companyWebsiteAddress: [
          {
            required: true,
            message: '请输入公司网址',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  mounted () {
    // if(this.id){
    //   this.devForm = this.co
    // }
  },
  methods: {
    save () {
      this.loading = true
      this.$refs.devForm.validate(async valid => {
        // 验证通过
        if (valid) {
          // 重置表单
          try {
            if (this.devForm.password !== this.devForm.cfrmpassword) {
              this.$message.error('两次密码不一致')
              this.loading = false
              return false
            }
            await devService.saveDev(this.devForm)
            this.$refs.devForm.resetFields()
            this.$message.success('创建开发者成功，请前往审核！')
            this.$router.push({name: 'devmanage'})
            // this.$emit('success')
            this.loading = false
            // this.devDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    },
    reset () {
      if (this.$refs.devForm) {
        this.devForm = {}
        this.fileList2 = []
        this.$refs.devForm.resetFields()
      }
    },
    saveAndReset () {
      this.loading = true
      this.$refs.devForm.validate(async valid => {
        // 验证通过
        if (valid) {
          // 重置表单
          try {
            if (this.devForm.password !== this.devForm.cfrmpassword) {
              this.$message.error('两次密码不一致')
              this.loading = false
              return false
            }
            await devService.saveDev(this.devForm)
            this.$refs.devForm.resetFields()
            // this.$emit('success')
            this.$message.success('创建开发者成功！')
            this.loading = false
            // this.devDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    },
    handleRemove (file, fl) {
      this.fileList2 = []
      this.devForm.businessLicenseUrl = ''
    },
    uploadHandle_exceed(files, fileList){
      this.$message.error('最多上传一张图片，请先删除再上传')
    },
    
    /* 上传之前校验 */
    uploadHandle_before(file) {  
      // 格式
      let ext = file.name.substring(file.name.lastIndexOf('.')+1) 
      if (['jpg','png'].indexOf(ext.toLowerCase())==-1) {
          this.$message.error('上传图片格式错误!');
          return false;
      }
      // 大小
      if (file.size / (10 * 1024 * 1024) > 1) {
          this.$message.error('上传图片大小不得超过10M!');
          return false;
      }
      
      return true;
    },

    handleSuccess (response, file, fileList2) {
      this.fileList = []
      this.fileList.push(file)
      this.devForm.businessLicenseUrl = response.data
    }
  },
  watch: {
    // devDialogVisible (newVal, oldVal) {
    //   this.title = '新增开发者'
    //   if (newVal && this.$refs.devForm) {
    //     this.devForm = {}
    //     this.fileList2 = []
    //     this.$refs.devForm.resetFields()
    //   }
    // }
  },
  computed: {
    // devDialogVisible: {
    //   get () {
    //     return this.value
    //   },
    //   set (val) {
    //     this.$emit('input', val)
    //   }
    // }
  }
}
</script>
<style scoped>
.devDialog{
  padding-top: 10px;
}
.devDialog .add-header{
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #F2F2F2;
}
.devDialog .add-header .title{
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  padding-left: 24px;
}
.devDialog .dev_form_title{
  font-weight: bold;
  color: #333333;
  font-size: 14px;
  margin-bottom: 50px;
}
.devDialog .devDialog-content{
  background-color: white;
  overflow: hidden;
}
.devDialog .devDialog-content .form-box{
  width: 50%;
  margin: 30px auto;
}
.devDialog .devDialog-content .dialog-footer{
  text-align: center;
}
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/add-developer/index.vue